import React from "react";

export const ChartTooltip = ({
  color,
  title,
  datum,
  formatX,
  formatY,
  xKey,
  yKey,
}) => (
  <>
    <div
      className="title"
      style={color ? { color: "white", backgroundColor: color } : {}}
    >
      {title}
    </div>
    <div className="content">
      {formatX({ value: datum[xKey] })}: {formatY({ value: datum[yKey] })}
    </div>
  </>
);

export default ChartTooltip;
